import React, { useState, useEffect } from "react";
import { Box, Grid } from "@mui/material";
import CustomButton from "../../components/Button";
import CustomInput from "../../components/Input";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import * as _ from "underscore";
import { Colors } from "../../constants/Colors";
import { apiRequest } from "../../services/api-request";
import SelectPicker from "../../components/SelectPicker";

import { useAppContext } from "../../context/AppContext";

const AddEditUser = (props) => {
  const { user } = useAppContext();

  const { currentState = {} } = props;

  const schema = yup
    .object({
      name: yup.string().required("Loan Officer name is required"),
      mobile: yup.string().required("Mobile number is required"),
      selectState: yup.string().required("State is required"),
      // selectMandal: yup.string().required("Mandal is required"),
      // selectDistrict: yup.string().required("District is required"),
      // selectVillage: yup.string().required("Village is required"),
      //selectHamlet: yup.string().required("Hamlet is required"),
      password: yup
        .string()
        .required("Password is required")
        .min(6, "Minimum Six Characters required"),

      selectBranch: yup.string().required("Branch is required"),
      selectRegional: yup.string().required("Regional is required"),
      selectCircle: yup.string().required("Circle is required"),
    })
    .required();

  const getEditUserDetails = (isEdit, currentState) => {
    const role = user?.role?.code;
    if (!isEdit) {
      return {
        name: "",
        mobile: "",
        selectState: "",
        // selectMandal: "",
        // selectDistrict: "",
        // selectVillage: "",
        //selectHamlet: "",
        selectBranch: "",
        selectRegional: "",
        selectCircle: "",
      };
    } else {
      return {
        name: currentState?.name,
        mobile: currentState?.mobile,
        selectState: currentState?.stateId,
        // selectDistrict:
        //   `${
        //     role === "admin" ? currentState?.districtId : currentState?.district
        //   }` || currentState?.district,
        // selectMandal:
        //   `${
        //     role === "admin" ? currentState?.mandalId : currentState?.mandal
        //   }` || currentState?.mandal,
        // selectVillage:
        //   `${
        //     role === "admin" ? currentState?.villageId : currentState?.village
        //   }` || currentState?.village,
        //selectHamlet: currentState?.hamletId,
          selectBranch: currentState?.branch_id,
          selectRegional: currentState?.regional_id,
          selectCircle: currentState?.circle_id,

      };
    }
  };

  const { handleSubmit, control, watch } = useForm({
    resolver: yupResolver(schema),
    defaultValues: getEditUserDetails(props?.isEdit, currentState),
  });

  const [statesList, setStatesList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [mandalList, setMandalList] = useState([]);
  const [villageList, setVillageList] = useState([]);
  const [hamletList, setHamletList] = useState([]);

  const [circleList, setCircleList] = useState({
    data: [],
    loader: false,
  });
  const [regionalList, setRegionalList] = useState({
    data: [],
    loader: false,
  });
  const [branchList, setBranchList] = useState({
    data: [],
    loader: false,
  });

  const getCirlces = (state_id) => {
    apiRequest({
      url: "bank/get-circle-office?state_id="+state_id,
      method: "GET",
    })
      .then((res) => {
        const getList = res?.data?.map((elem) => ({
            name: elem?.name,
            value: elem?.id,
          }));
          setCircleList({ data: getList, loader: false });
      })
      .catch((err) => {
        alert(err?.response?.data?.message, "error");
      });
  };

  useEffect(() => {
    if (watch("selectCircle")) {
      setRegionalList({data: []});
      setBranchList({data: []});
      getRegionals(watch("selectCircle"));
    }
  }, [watch("selectCircle")]);

  const getRegionals = (circle_id) => {
    apiRequest({
      url: "bank/get-regional-office?circle_id="+circle_id,
      method: "GET",
    })
      .then((res) => {
        const getList = res?.data?.map((elem) => ({
            name: elem?.name,
            value: elem?.id,
          }));
          setRegionalList({ data: getList, loader: false });
      })
      .catch((err) => {
        alert(err?.response?.data?.message, "error");
      });
  };

  useEffect(() => {
    if (watch("selectRegional")) {
      setBranchList({data: []});
      getBranches(watch("selectRegional"));
    }
  }, [watch("selectRegional")]);

  const getBranches = (regional_id) => {
    apiRequest({
      url: "bank/get-branch?regional_id="+regional_id,
      method: "GET",
    })
      .then((res) => {
        const getList = res?.data?.map((elem) => ({
            name: elem?.name,
            value: elem?.id,
          }));
          setBranchList({ data: getList, loader: false });
      })
      .catch((err) => {
        alert(err?.response?.data?.message, "error");
      });
  };

  useEffect(() => {
    getStates();
  }, []);

  useEffect(() => {
    if (watch("selectState")) {
      setDistrictList([]);
      setMandalList([]);
      setVillageList([]);
      setHamletList([]);
      getDistricts(watch("selectState"));
      setCircleList({data: []});
      setRegionalList({data: []});
      setBranchList({data: []});
      getCirlces(watch("selectState"));
    }
  }, [watch("selectState")]);

  useEffect(() => {
    if (watch("selectDistrict")) {
      setMandalList([]);
      setVillageList([]);
      setHamletList([]);
      getMandalsList(watch("selectDistrict"));
    }
  }, [watch("selectDistrict")]);

  useEffect(() => {
    if (watch("selectMandal")) {
      setVillageList([]);
      setHamletList([]);
      getVillageList(watch("selectMandal"));
    }
  }, [watch("selectMandal")]);

  useEffect(() => {
    if (watch("selectVillage")) {
      setHamletList([]);
      getHamletList(watch("selectVillage"));
    }
  }, [watch("selectVillage")]);

  const getStates = () => {
    const URL =
      `master/states`
    apiRequest({
      url: URL,
      method: "GET",
    })
      .then((res) => {
        const getStates = res?.data?.map((state) => ({
          name: state?.display_name,
          value: state?.id,
        }));
        setStatesList(getStates);
      })
      .catch((err) => {
        alert(err?.response?.data?.message, "error");
      });
  };

  const getDistricts = (stateName) => {
    const URL = `master/districts`
    const payload = {
      state_id: Number(stateName),
      limit: 5000,
    };
    apiRequest({
      url: URL,
      method: "POST",
      data: payload,
    })
      .then((res) => {
        const getDistricts = res?.data?.map((district) => ({
          name: district?.name,
          value: district?.id,
        }));
        setDistrictList(getDistricts);
      })
      .catch((err) => {
        alert(err?.response?.data?.message, "error");
      });
  };

  const getMandalsList = (districtName) => {
    const URL = `master/mandals`

    const payload = {
      district_id: Number(districtName),
      limit: 5000,
    };
    apiRequest({
      url: URL,
      method: "POST",
      data: payload,
    })
      .then((res) => {
        const modifiedMandalList = res?.data?.map((mandal) => ({
          name: mandal?.name,
          value: mandal?.id,
        }));
        setMandalList(modifiedMandalList);
      })
      .catch((err) => {
        alert(err?.response?.data?.message, "error");
      });
  };

  const getVillageList = (mandalId) => {
    const payload = {
      mandal_id: Number(mandalId),
      limit: 1000,
    };
    const URL = `master/villages`
    apiRequest({
      url: URL,
      data: payload,
      method: "POST",
    })
      .then((res) => {
        const modifiedVillageList = res?.data?.map((village) => ({
          name: village?.name,
          value: village?.id,
        }));
        setVillageList(modifiedVillageList);
      })
      .catch((err) => {
        alert(err);
      });
  };

  const getHamletList = (villageId) => {
    const payload = {
      village_id: Number(villageId),
    };
    apiRequest({
      url: `master/hamlets`,
      data: payload,
      method: "POST",
    })
      .then((res) => {
        const hamletResponse = res?.data?.map((hamlet) => ({
          name: hamlet?.name,
          value: hamlet?.id,
        }));
        setHamletList(hamletResponse);
      })
      .catch((err) => {
        alert(err);
      });
  };

  const onSubmit = (data) => {
    let payload = {
      user_type:'LOAN_OFFICER',
      mobile: data?.mobile,
      password: data?.password,
      name: data?.name,
      state_id: parseFloat(data?.selectState),
      state_name: _.where(statesList, {value: parseFloat(data?.selectState)})[0].name,
      // district_id: parseFloat(data?.selectDistrict),
      // district_name: _.where(districtList, {value: parseFloat(data?.selectDistrict)})[0].name,
      // mandal_id: parseFloat(data?.selectMandal),
      // mandal_name: _.where(mandalList, {value: parseFloat(data?.selectMandal)})[0].name,
      // village_id: parseFloat(data?.selectVillage),
      // village_name: _.where(villageList, {value: parseFloat(data?.selectVillage)})[0].name,
      // hamlet_id: parseFloat(data?.selectHamlet),
      // hamlet_name: _.where(hamletList, {value: parseFloat(data?.selectHamlet)})[0].name,
      branch_id: data?.selectBranch,
      regional_id: data?.selectRegional,
      circle_id: data?.selectCircle,
    };
    apiRequest({
      url: `bank/add-loan-officer-veterinary`,
      data: payload,
      method: "POST",
    })
      .then((res) => {
        if (res?.success === false) {
          alert(res?.message);
        }
        if (res?.success === true) {
          alert(res?.message);
        }
        props.getUsersByType();
        props.onCancel();
      })
      .catch((err) => {
        console.log(err);
        alert(err?.response?.data?.message, "error");
      });
  };

  return (
    <>
      <Box sx={{ width: "100%", padding: "20px 0px 0px 0px" }}>
        <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
          <Grid
            container
            alignItems={"baseline"}
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
          >
            <Grid item xs={6}>
              <Box>
                <Controller
                  name="name"
                  control={control}
                  render={({ field, fieldState: { error } }) => (
                    <CustomInput
                      {...field}
                      inputLabel={"Name"}
                      type={"text"}
                      placeholder={"Enter Farmer Name"}
                      error={!!error}
                      helperText={error ? error.message : ""}
                    />
                  )}
                />
              </Box>
            </Grid>

            <Grid item xs={6}>
              <Box>
                <Controller
                  name="password"
                  control={control}
                  render={({ field, fieldState: { error } }) => (
                    <CustomInput
                      {...field}
                      inputLabel={"Password"}
                      type={"text"}
                      error={!!error}
                      helperText={error ? error.message : ""}
                    />
                  )}
                />
              </Box>
            </Grid>

            <Grid item xs={6}>
              <Box>
                <Controller
                  name="mobile"
                  control={control}
                  render={({ field, fieldState: { error } }) => (
                    <CustomInput
                      {...field}
                      inputLabel={"Mobile"}
                      type={"number"}
                      placeholder={"Enter Mobile Number"}
                      error={!!error}
                      helperText={error ? error.message : ""}
                    />
                  )}
                />
              </Box>
            </Grid>

            <Grid item xs={6}>
              <Box>
                <Controller
                  name="selectState"
                  control={control}
                  render={({ field, fieldState: { error } }) => (
                    <SelectPicker
                      {...field}
                      options={statesList}
                      labelText={""}
                      type={"text"}
                      placeholder={"Select State"}
                      error={!!error}
                      helperText={error ? error.message : ""}
                    />
                  )}
                />
              </Box>
            </Grid>

            {/*<Grid item xs={6}>
              <Box>
                <Controller
                  name="selectDistrict"
                  control={control}
                  render={({ field, fieldState: { error } }) => (
                    <SelectPicker
                      options={districtList}
                      {...field}
                      labelText={""}
                      type={"text"}
                      placeholder={"Select District"}
                      error={!!error}
                      helperText={error ? error.message : ""}
                      defaultOption={"Select State to get Districts"}
                    />
                  )}
                />
              </Box>
            </Grid>

            <Grid item xs={6}>
              <Box>
                <Controller
                  name="selectMandal"
                  control={control}
                  render={({ field, fieldState: { error } }) => (
                    <SelectPicker
                      options={mandalList}
                      {...field}
                      labelText={""}
                      type={"text"}
                      placeholder={"Select Mandal"}
                      error={!!error}
                      helperText={error ? error.message : ""}
                      defaultOption={"Select Districts to get Mandals"}
                    />
                  )}
                />
              </Box>
            </Grid>

            <Grid item xs={6}>
              <Box>
                <Controller
                  name="selectVillage"
                  control={control}
                  render={({ field, fieldState: { error } }) => (
                    <SelectPicker
                      options={villageList}
                      {...field}
                      labelText={""}
                      type={"text"}
                      placeholder={"Select Village"}
                      error={!!error}
                      helperText={error ? error.message : ""}
                      defaultOption={"Select Mandals to get Villages"}
                    />
                  )}
                />
              </Box>
            </Grid>*/}

            {/*<Grid item xs={6}>
              <Box>
                <Controller
                  name="selectHamlet"
                  control={control}
                  render={({ field, fieldState: { error } }) => (
                    <SelectPicker
                      options={hamletList}
                      {...field}
                      labelText={""}
                      type={"text"}
                      placeholder={"Select Hamlet"}
                      error={!!error}
                      helperText={error ? error.message : ""}
                    />
                  )}
                />
              </Box>
            </Grid>*/}

            <Grid item xs={6}>
              <Box>
                <Controller
                  name="selectCircle"
                  control={control}
                  render={({ field, fieldState: { error } }) => (
                    <SelectPicker
                      options={circleList.data}
                      {...field}
                      labelText={""}
                      type={"text"}
                      placeholder={"Select Circle"}
                      error={!!error}
                      helperText={error ? error.message : ""}
                    />
                  )}
                />
              </Box>
            </Grid>

            <Grid item xs={6}>
              <Box>
                <Controller
                  name="selectRegional"
                  control={control}
                  render={({ field, fieldState: { error } }) => (
                    <SelectPicker
                      options={regionalList.data}
                      {...field}
                      labelText={""}
                      type={"text"}
                      placeholder={"Select Regional"}
                      error={!!error}
                      helperText={error ? error.message : ""}
                    />
                  )}
                />
              </Box>
            </Grid>

            <Grid item xs={6}>
              <Box>
                <Controller
                  name="selectBranch"
                  control={control}
                  render={({ field, fieldState: { error } }) => (
                    <SelectPicker
                      options={branchList.data}
                      {...field}
                      labelText={""}
                      type={"text"}
                      placeholder={"Select Branch"}
                      error={!!error}
                      helperText={error ? error.message : ""}
                    />
                  )}
                />
              </Box>
            </Grid>

          </Grid>

          <Grid
            container
            alignItems={"end"}
            justifyContent={"flex-end"}
            mt={2}
            gap={2}
          >
            <Grid item>
              <CustomButton
                title={`Cancel`}
                backgroundColor={Colors.white}
                textColor={Colors.headerColor}
                borderColor={Colors.headerColor}
                textFontSize={14}
                handleButtonClick={props?.onCancel}
                variant={"outlined"}
                width={130}
                height={34}
              />
            </Grid>
            <Grid item>
              <CustomButton
                variant={"contained"}
                title={`Submit`}
                backgroundColor={Colors.headerColor}
                textColor={Colors.white}
                borderColor={Colors.headerColor}
                textFontSize={14}
                type={"submit"}
                width={130}
                height={34}
              />
            </Grid>
          </Grid>
        </form>
      </Box>
    </>
  );
};

export default AddEditUser;
